import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import AOS from "aos";
import 'aos/dist/aos.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { setStorage, getStorage } from 'lonjin-helper'
import BaseFooter from '@/components/BaseFooter.vue'
import Swiper from '@/utils/swiper.min.js'
import '@/assets/scss/swiper.min.css';
import VueMeta from 'vue-meta';
Vue.prototype.$aos = AOS

Vue.config.productionTip = false

import api from './axios/api'

Vue.component('BaseFooter', BaseFooter)

Vue.prototype.$api = api;
Vue.prototype.$setStorage = setStorage;
Vue.prototype.$getStorage = getStorage;
Vue.prototype.$Swiper = Swiper
Vue.use(ElementUI);

console.log('1.0.2')


new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
